var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.items),function(item){return _c('li',{staticClass:"list__item"},[_c('img',{attrs:{"src":_vm.getSrc(item.icon),"alt":""}}),_vm._v(" "),_vm._t("default",[_c('span',[_vm._v(_vm._s(item.text))])])],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }